import { createContext, useCallback, useContext, useEffect, useState } from "react";
import iconNotification from "../../assets/notification/icon.svg";
import notificationSound from "../../assets/notification/notification.mp3";
import { useApp } from "../../hooks/useApp";
import { notificationNewCountMessage } from "../../services/whatsapp/WhatsAppService";
import { getEmailUnreadCounts } from "../../services/email/EmailHistoryService";

import "react-pro-sidebar/dist/css/styles.css";
import { WebSocketContext } from "../../contexts/WebSocketContext";

const SidebarDataContext = createContext();

const SidebarDataContextProvider = ({ children }) => {
  const [selectedMenuItem, setSelectedMenuItem] = useState("Dashboard");
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [newMessageClient, setNewMessageClient] = useState(false);
  const [newMessageLead, setNewMessageLead] = useState(false);
  const [selected, setSelected] = useState("Dashboard");
  const [processedNewMessagesCount, setProcessedNewMessagesCount] = useState(0);
  const [personWithNewMessage, setPersonWithNewMessage] = useState();
  const [prevMessagesCount, setPrevMessagesCount] = useState({});

  const [emailUnreadMap, setEmailUnreadMap] = useState({});
  const [emailUnreadTotal, setEmailUnreadTotal] = useState(0);
  const [hasNewEmail, setHasNewEmail] = useState(false);

  const [toggled, setToggled] = useState(false);
  const [broken, setBroken] = useState(false);

  const { setMessageUser, setNewMessageTimeout, authInfo } = useApp();

  const {
    notificationsWS,
    notificateClientWS,
    sendNotificateWS,
    webSocketActive,
  } = useContext(WebSocketContext);

  const playNotificationSound = () => {
    const audio = new Audio(notificationSound);

    audio.play().catch((error) => {
      console.error("Error al reproducir el sonido:", error);
      // playNotificationSound();
    });
  };

  useEffect(() => {
    const updateFavicon = () => {
      const favicon = document.querySelector('link[rel="icon"]');
      favicon.href = iconNotification;

      if (processedNewMessagesCount > 0) {
        favicon.href = "";
      }
    };

    updateFavicon();

    // const interval = setInterval(obtenerMensajes, 10000);

    // return () => {
    //     clearInterval(interval);
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevMessagesCount]);

  const obtenerMensajes = async () => {
    try {
      if (authInfo && authInfo.id && authInfo.userRole.id) {
        const response = await notificationNewCountMessage(
          authInfo.id,
          authInfo.userRole.id
        );
        if (response && response.content.length > 0) {
          let playSound = false;
          setNewMessageTimeout(response.content);
          // Verificar si hay nuevos mensajes para clientes prospecto y no prospecto

          let hasNewLeadMessages = false;
          let hasNewClientMessages = false;
          let newClientNotification = [];

          response.content.forEach((item) => {
            if (item?.client?.prospect == true && item?.countNewMessages > 0) {
              hasNewLeadMessages = true;
            }
            if (item?.client?.prospect == false && item?.countNewMessages > 0) {
              hasNewClientMessages = true;
            }
            newClientNotification.push({
              type: "add",
              clientId: item.client.id,
            });
          });

          // const hasNewLeadMessages = response.content.some(item => item?.client?.prospect==true && item?.countNewMessages > 0);
          // const hasNewClientMessages = response.content.some(item => item?.client?.prospect==false && item?.countNewMessages > 0);

          // Actualizar el estado de nuevos mensajes para clientes prospecto y no prospecto
          setNewMessageLead(hasNewLeadMessages);
          setNewMessageClient(hasNewClientMessages);

          if (newClientNotification && newClientNotification.length > 0)
            sendNotificateWS(newClientNotification);

          // Actualizar el estado de mensajes de usuario con la respuesta completa
          setMessageUser(response.content);

          response.content.forEach((message) => {
            const userId = message.client.id;
            const newCount = message.countNewMessages;
            const prevCount = prevMessagesCount[userId] || 0;
            if (newCount > prevCount) {
              playSound = true;
              // Actualizar el estado previo para este usuario
              setPrevMessagesCount((prev) => ({
                ...prev,
                [userId]: newCount,
              }));
            }
          });

          if (playSound) {
            playNotificationSound();
            const favicon = document.querySelector('link[rel="icon"]');
            favicon.href = iconNotification;
            localStorage.setItem("hasSeenNewMessages", "true");
          }

          setProcessedNewMessagesCount(response.content.length);
          setPersonWithNewMessage(response.content);
        } else {
          // Si no hay nuevos mensajes, actualizar el estado correspondiente y eliminar el ícono de notificación
          setProcessedNewMessagesCount(0);
          const favicon = document.querySelector('link[rel="icon"]');
          favicon.href = "";
          setNewMessageClient(false);
          setNewMessageLead(false);
          setMessageUser([]);
        }
      }
    } catch (error) {
      console.error("Error al obtener mensajes:", error);
    }
  };

  const obtenerEmailUnread = useCallback(async () => {
    try {
      if (authInfo && authInfo.id) {
        const counts = await getEmailUnreadCounts();
        if (counts && typeof counts === "object") {
          setEmailUnreadMap(counts);
          const total = Object.values(counts).reduce((sum, c) => sum + (c || 0), 0);
          setEmailUnreadTotal(total);
          setHasNewEmail(total > 0);
        } else {
          setEmailUnreadMap({});
          setEmailUnreadTotal(0);
          setHasNewEmail(false);
        }
      }
    } catch (error) {
      console.error("Error al obtener unread email counts:", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authInfo?.id]);

  useEffect(() => {
    obtenerEmailUnread();
    const interval = setInterval(obtenerEmailUnread, 60000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authInfo]);

  //Notifications WebSocket
  useEffect(() => {
    // if(notificationsWS?.messageIncoming){
    obtenerMensajes();
    // }
  }, [notificationsWS]);

  //Notificar Client message WebSocket
  useEffect(() => {
    obtenerMensajes();
    // if(notificateClientWS && notificateClientWS.length === 0) {
    //     obtenerMensajes();
    //     // setNewMessageClient(false);
    // }
  }, [notificateClientWS]);

  return (
    <SidebarDataContext.Provider
      value={{
        selectedMenuItem,
        setSelectedMenuItem,
        isCollapsed,
        setIsCollapsed,
        newMessageClient,
        setNewMessageClient,
        newMessageLead,
        setNewMessageLead,
        processedNewMessagesCount,
        setProcessedNewMessagesCount,
        selected,
        setSelected,
        personWithNewMessage,
        notificationsWS,
        sendNotificateWS,
        notificateClientWS,
        webSocketActive,
        toggled,
        setToggled,
        broken,
        setBroken,
        emailUnreadMap,
        emailUnreadTotal,
        hasNewEmail,
        refreshEmailUnread: obtenerEmailUnread,
      }}
    >
      {children}
    </SidebarDataContext.Provider>
  );
};

// Hook personalizado para usar el contexto
const useSidebarData = () => {
  return useContext(SidebarDataContext);
};

export { SidebarDataContext, SidebarDataContextProvider, useSidebarData };
